import { Injectable } from '@angular/core';
import { LoadingController, Events, AlertController, PopoverController } from 'ionic-angular';
import { Http, RequestOptions, URLSearchParams, QueryEncoder } from '@angular/http';
import 'rxjs/add/operator/map';

import { Storage } from '@ionic/storage';

import { Network } from '@ionic-native/network';


import { UserProvider } from '../user/user';
import { ConfigProvider } from '../config/config';

declare var require;

import base64url from "base64url";
var crypto = require('crypto');
var jwt = require('jsonwebtoken');


//ALERT:
// The following is a fix for URLSearchParams,
// which doesn't correctly treat the + character in a string,
// so phone numbers with + country codes are being sent without the +
// solution from here:
// https://github.com/angular/angular/issues/11058
//
// Note we also have to add the import for QueryEncoder from @angular/http

class GhQueryEncoder extends QueryEncoder {
  encodeKey(k: string): string {
      k = super.encodeKey(k);
      return k.replace(/\+/gi, '%2B');
  }
  encodeValue(v: string): string {
      v = super.encodeKey(v);
      return v.replace(/\+/gi, '%2B');
  }
}


@Injectable()
export class ApiProvider {

  url: string = window.location.protocol + '//' + window.location.host + '/api/';
  env: any;
  connectSubscription: any;
  disconnectSubscription: any;
  connected: any;

  jwtHeader = {
    "alg": "HS256",
    "typ": "JWT"
  };

  token: string;
  secret: string    = 'V4-g#,j"UuYMFsPA';
  loginSecret: string;
  isLoggedIn: boolean = false;
  algorithm: string = 'sha256';
  hash: any;
  hmac: any;
  loading: any;
  popover: any;
  packageShowing: boolean = false;

  localhost:boolean = false;

  constructor(
    public http: Http,
    public user: UserProvider,
    public config: ConfigProvider,
    public alertCtrl: AlertController,
    public popoverCtrl: PopoverController,
    public loadingCtrl: LoadingController,
    public network: Network,
    public storage: Storage,
    public events: Events) {
  
      this.disconnectSubscription = this.network.onDisconnect().subscribe(() => {
        this.events.publish('app:connected', false);
      });
      this.connectSubscription = this.network.onConnect().subscribe(() => {
        this.events.publish('app:connected', true);
      });

      if(window.location.href.toString().indexOf('localhost') != -1){ // dev
        this.localhost = true;
        this.url = 'https://admin.finstr.com/api/';
      }
      console.log('api url', this.url);
  }

  getJWT(payload){
    return new Promise(resolve => {
      this.getSecret().then((secret)=>{
        resolve(jwt.sign(payload, secret));
      });
    });
  }

  decodeJWT(token){
    return new Promise(resolve => {
      this.getSecret().then((secret)=>{
        return(jwt.decode(token, secret));
      });
    });
  }

  getSecret(){
    return new Promise((resolve) => {
      this.storage.get('loggedIn').then((isLoggedIn)=>{
        this.storage.get('api.loginSecret').then((loggedInSecret)=>{
          //console.log('isLoggedIn', isLoggedIn);
          //console.log('secret from storage', loggedInSecret);
          let secret = loggedInSecret && isLoggedIn? loggedInSecret : this.secret;
          //console.log('resolving with', secret);
          resolve(secret);
        });
      });
    });
  }

  post(endpoint: string, params?: any, options?: RequestOptions) {
    //this.checkLogin();
    params = params || {};
    if(!params.doNotShowLoading && !params.loadPackage){
      //this.showLoading();
    }
    return new Promise(resolve => {
      
      this.showPackage(params).then(()=>{
        delete params.loadPackage;
      
        this.user.load().then(()=>{
          if(!options){
            options = new RequestOptions();
          }
          if(!params.doNotSendAccessData){
            let accessData = this.user.getAccessData();
            for(var i in accessData){
              if(i == 'homepage' || i == 'login_profile') continue;
              params[i] = accessData[i];
            }
            if(this.config.debug){
              console.log('sent', params);
            }
          } else {
            delete params.doNotSendAccessData;
          }
         // delete params.homepage;
          

          this.getSecret().then((secret)=>{
            if(this.config.debug){
              //console.log('this.secret', this.secret);
              //console.log('secret', secret);
              //console.log('isLoggedIn', this.isLoggedIn);
            }
            this.getJWT(params).then((token: any)=>{
              if(this.localhost){
                //let p = new URLSearchParams('', new GhQueryEncoder());
                //p.set('token', token);
                //options.search = !options.search && p || options.search;
                
              }
              this.http.post(this.url + endpoint, { token: token }, options).map(res=>{
                if(params.returnRaw) return res;
                try {
                  //console.log('trying res.json()');
                  res = res.json();
                  //console.log(res);
                  return res;
                } catch(e){
                  //console.log('failed, trying decodeJWT');
                  //console.log('with res:', res['_body']);
                  //console.log('and secret:', secret);
                  try {
                    // we are using jwt
                    res = jwt.verify(res['_body'], secret);
                    //console.log('jwt res', res);
                    return res;
                  } catch(e){
                    // the token is invalid                  
                    // or we got an error message
                    return {};
                    /*                    
                    - log them out   
                    return {
                      env: {},
                      data: {
                        forceLogout: true
                      }
                    };
                    */                    
                  }                
                }          
              }).subscribe((res: any)=>{
                if(params.returnRaw){
                  //console.log('rawRes', res);
                  resolve(res);
                  return;
                }
                if(this.packageShowing){
                  // setTimeout(()=>{
                  this.popover.dismiss();
                  this.hideLoading();
                  this.packageShowing = false;
                   //},500);
                } 
                if(this.config.debug){
                  console.log('got from '+params.action, res);
                }
                if(!res.env){
                  //console.log('no env, '+params.action, res);
                  resolve(res);                  
                } else {
                  if(res.env){
                    this.env = res.env;
                    this.events.publish('env:set', res.env);
                  }
                  
                  if(!params.doNotShowLoading && !params.loadPackage){
                    //this.hideLoading();
                  }

                  res.data = res.data || {};
                  res.user = res.user || {};

                  // handle user-related stuff here
                  if(res.result_type == 'np'){
                    //console.log('api no permissions');
                    // permissions failure for whatever the request was
                    // we publish it so Siri can pick it up
                    this.events.publish('api:noPermissions', res);
                  }
                  if(res.data.forceLogout){
                    //console.log('forceLogout');
                    this.user.logout();
                  } else {

                    if(res.loginSecret){
                      this.storage.set('api.loginSecret', res.loginSecret);
                    }
                    this.user.clearAccessData();
                    this.user.setAccessData(res.user);
                    this.events.publish('exp:reset');
                    if(res.menu){
                      this.user.setHomePage(res.homepage);
                      this.user.setMenu(res.menu);
                    }
                 
                  }
                  resolve(res);       
                }
              // this is fun  
              }, (err) => { this.hideLoading(); console.log(err); }), e => console.log(e), e => console.log(e);
            }).catch(function(e){ console.log(e); });
          }).catch(function(e){ console.log(e); });
        }).catch(function(e){ console.log(e); });
      }).catch(function(e){ console.log(e); });
    }).catch(function(e){ console.log(e); });
  }

  showLoading(){}

  hideLoading(){}

  showPackage(params){
    return new Promise((resolve, reject)=>{
      resolve();
    });
  }


}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts